import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    meta: { title: "威硬网站" },
    component: () => import("../views/home.vue"),
  },
  {
    path: "/advantage",
    name: "advantage",
    meta: { title: "威硬网站-走进威硬" },
    component: () => import("../views/advantage/index.vue"),
  },
  {
    path: "/culture",
    name: "culture",
    meta: { title: "威硬网站-文化荣誉" },
    component: () => import("../views/corporate-culture/index.vue"),
  },
  {
    path: "/product",
    name: "product",
    meta: { title: "威硬网站-产品中心" },
    component: () => import("../views/product/index.vue"),
  },
  {
    path: "/product-detail",
    name: "product-detail",
    meta: { title: "威硬网站-产品详情" },
    component: () => import("../views/product/detail.vue"),
  },
  {
    path: "/leave-msg",
    name: "leave-msg",
    meta: { title: "威硬网站-在线留言" },
    component: () => import("../views/leave-msg/index.vue"),
  },
  {
    path: "/concat",
    name: "concat",
    meta: { title: "威硬网站-联系我们" },
    component: () => import("../views/concat/index.vue"),
  },
  {
    path: "/404",
    name: "404",
    meta: { title: "404" },
    component: () => import("../views/notFound/index.vue"),
  },
  {
    path: "/:pathMatch(.*)",
    redirect: "/404",
  },
];

const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title;
  }
  next(); // 继续路由导航
});

export default router;
